import * as React from 'react';
import type { City } from 'contracts/Cities';
import { api, applyQueryString } from 'services';

import { optionsMapper, multiSelectorOptionsMapper } from '../utils';

export function useCityOptions() {
  const fetchCities = React.useCallback(async (state: string | string[]) => {
    const stateString = Array.isArray(state)
      ? state.join(',')
      : state;

    const url = applyQueryString('/cities', {
      asList: true,
      state: stateString,
    });

    const { data } = await api.get<City[]>(url);

    const options = data.map((city) => {
      const { name, uf, ibge } = city;

      const label = Array.isArray(state) && state.length > 1
        ? `${name}/${uf}`
        : name;

      return {
        label,
        value: ibge.toString(),
      };
    });

    return {
      singleSelectOptions: options.map(optionsMapper),
      multiSelectOptions: options.map(multiSelectorOptionsMapper),
    };
  }, []);

  return {
    fetchCities,
  };
}
